"use strict";
exports.__esModule = true;
exports.template = exports.dash = exports._dash = exports.snake = exports._snake = exports.camal = exports._camal = exports.capitalize = void 0;
var capitalize = function (str) {
    if (!str || str.length === 0)
        return '';
    var lower = str.toLowerCase();
    return lower.substring(0, 1).toUpperCase() + lower.substring(1, lower.length);
};
exports.capitalize = capitalize;
/**
 * Joins all string arguments in a camal case fashion
 *
 * camal('hello', 'world')   -> 'helloWorld'
 * camal('va', 'va', 'voom') -> 'vaVaVoom'
 */
var _camal = function () {
    var parts = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        parts[_i] = arguments[_i];
    }
    if (parts.length === 0)
        return '';
    if (parts.length === 1)
        return parts[0];
    return parts.reduce(function (acc, part) {
        return "" + acc + part.charAt(0).toUpperCase() + part.slice(1);
    });
};
exports._camal = _camal;
var camal = function (str) {
    return exports._camal.apply(void 0, str.split(/[\.\-\s_]/).map(function (x) { return x.toLowerCase(); }));
};
exports.camal = camal;
/**
 * Joins all string arguments in a snake case fashion
 *
 * camal('hello', 'world')   -> 'hello_world'
 * camal('va', 'va', 'voom') -> 'va_va_voom'
 */
var _snake = function () {
    var parts = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        parts[_i] = arguments[_i];
    }
    if (parts.length === 0)
        return '';
    if (parts.length === 1)
        return parts[0];
    return parts.reduce(function (acc, part) {
        return acc + "_" + part.toLowerCase();
    });
};
exports._snake = _snake;
var snake = function (str) {
    return exports._snake.apply(void 0, str.split(/[\.\-\s_]/).map(function (x) { return x.toLowerCase(); }));
};
exports.snake = snake;
/**
 * Joins all string arguments in a dash case fashion
 *
 * camal('hello', 'world')   -> 'hello-world'
 * camal('va', 'va', 'voom') -> 'va-va-voom'
 */
var _dash = function () {
    var parts = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        parts[_i] = arguments[_i];
    }
    if (parts.length === 0)
        return '';
    if (parts.length === 1)
        return parts[0];
    return parts.reduce(function (acc, part) {
        return acc + "-" + part.toLowerCase();
    });
};
exports._dash = _dash;
var dash = function (str) {
    return exports._dash.apply(void 0, str.split(/[\.\-\s_]/).map(function (x) { return x.toLowerCase(); }));
};
exports.dash = dash;
/**
 * template is used to replace data by name in template strings.
 * The default expression looks for {{name}} to identify names.
 *
 * Ex. tempalte('Hello, {{name}}', { name: 'ray' })
 * Ex. template('Hello, <name>', { name: 'ray' }, /<(.+?)>/g)
 */
var template = function (str, data, regex) {
    if (regex === void 0) { regex = /\{\{(.+?)\}\}/g; }
    return Array.from(str.matchAll(regex)).reduce(function (acc, match) {
        return acc.replace(match[0], data[match[1]]);
    }, str);
};
exports.template = template;
//# sourceMappingURL=string.js.map